<template>
  <div class="dof-tag-group">
    <slot></slot>
  </div>
</template>

<script>
import { mixSelectableParent } from '../utils/mix-selectable-parent.js'

export default {
  mixins: [mixSelectableParent('dof-tag-group')]
}
</script>

<style scoped>
.dof-tag-group {
  flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// index.vue?3253f7ba